import React from 'react';

const AdminPanelSkeleton = () => (
  <section className="ops-panel admin-panel-skeleton" data-testid="admin-panel-skeleton">
    <div className="skeleton-title shimmer"></div>
    <div className="skeleton-grid">
      <div className="skeleton-card shimmer"></div>
      <div className="skeleton-card shimmer"></div>
      <div className="skeleton-card shimmer"></div>
      <div className="skeleton-card shimmer"></div>
    </div>
    <div className="skeleton-block shimmer"></div>
    <div className="skeleton-block shimmer"></div>
  </section>
);

export default AdminPanelSkeleton;